<template>
  <section class="card my-3 text-start" data-testid="provisioning-history">
    <div class="card-body">
      <div class="d-flex justify-content-between"><h2 class="h6">Einladungen und Profiländerungen</h2><button class="btn btn-sm btn-outline-secondary" @click="load">Aktualisieren</button></div>
      <div class="d-flex gap-2 my-2">
        <label>Einladungsstatus <select v-model="state" @change="page = 1; load()"><option value="">Alle</option><option>Pending</option><option>Failed</option><option>InvitationPending</option><option>Completed</option></select></label>
        <button :disabled="page === 1" @click="page--; load()">Zurück</button><span>Seite {{ page }}</span><button :disabled="requests.length < 50" @click="page++; load()">Weiter</button>
      </div>
      <p v-if="error" class="text-danger" role="alert">{{ error }}</p>
      <p v-if="warning" class="alert alert-warning">{{ warning }}</p>
      <p v-if="!requests.length && !profiles.length" class="text-muted">Keine Vorgänge vorhanden.</p>
      <div v-for="request in requests" :key="request.id" class="border-top py-2">
        <span>{{ request.email || request.id }} — {{ request.state }}</span>
        <button v-if="request.appUserId" class="btn btn-sm btn-link" @click="emit('selectUser', request.appUserId)">Benutzer anzeigen</button>
        <span v-if="request.failureCode" class="ms-2">{{ request.failureCode }}</span>
        <button v-if="request.isRecoverable" class="btn btn-sm btn-outline-primary ms-2" @click="act(request, 'retry')">Erneut prüfen und freigeben</button>
        <button v-if="request.canResend" class="btn btn-sm btn-outline-primary ms-2" @click="act(request, 'resend-invitation')">Einladung erneut senden</button>
      </div>
      <div v-for="request in profiles" :key="request.id" class="border-top py-2">
        <span>Profiländerung {{ request.appUserId }} — {{ request.state }}</span>
        <span v-if="request.failureCode" class="ms-2">{{ request.failureCode }}</span>
        <button v-if="request.isRecoverable" class="btn btn-sm btn-outline-primary ms-2" @click="retryProfile(request)">Erneut versuchen</button>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref, onMounted, defineExpose, defineEmits } from "vue";
import api from "@/axiosConfig";
import { useUserStore } from "@/stores/userStore";
const store = useUserStore();
const emit = defineEmits(["selectUser"]);
const page = ref(1), state = ref("");
const requests = ref([]), profiles = ref([]), error = ref(""), warning = ref("");
async function load() {
  error.value = "";
  try {
    requests.value = (await api.get("/admin/users/provisioning", { params: { page: page.value, pageSize: 50, state: state.value || undefined } })).data;
    if (store.isSystemAdmin) profiles.value = (await api.get("/admin/users/identity-changes")).data;
  } catch (_) { error.value = "Vorgänge konnten nicht geladen werden."; }
}
async function act(request, action) {
  try {
    const response = await api.post(`/admin/users/provisioning/${request.id}/${action}`);
    warning.value = response.data?.warning || "";
    await load();
  } catch (e) { error.value = e.response?.data?.detail || "Der Vorgang konnte nicht ausgeführt werden. Bitte prüfen Sie den Status."; }
}
async function retryProfile(request) {
  try { await api.post(`/admin/users/identity-changes/${request.id}/retry`); await load(); }
  catch (_) { error.value = "Die Profiländerung kann nicht erneut gestartet werden."; }
}
onMounted(load);
defineExpose({ load });
</script>
